export default __webpack_public_path__ + "static/media/enviro-plant.3dbdf274.png";